export interface Day {
  label: string;
  number: number;
}

export const weekDays: Day[] = [
  { label: 'SHORT_DAYS.MON', number: 1 },
  { label: 'SHORT_DAYS.TUE', number: 2 },
  { label: 'SHORT_DAYS.WED', number: 3 },
  { label: 'SHORT_DAYS.THU', number: 4 },
  { label: 'SHORT_DAYS.FRI', number: 5 },
  { label: 'SHORT_DAYS.SAT', number: 6 },
  { label: 'SHORT_DAYS.SUN', number: 7 }
];
